import { render, staticRenderFns } from "./CrmRequests.vue?vue&type=template&id=626ec08f&scoped=true&"
import script from "./CrmRequests.vue?vue&type=script&lang=js&"
export * from "./CrmRequests.vue?vue&type=script&lang=js&"
import style0 from "./CrmRequests.vue?vue&type=style&index=0&id=626ec08f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626ec08f",
  null
  
)

export default component.exports